import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence the harmless "ResizeObserver loop" warning that CRA's dev overlay
// surfaces from framer-motion/Lenis. Does not affect production.
const RO_MSG = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e?.message && e.message.includes(RO_MSG)) {
    e.stopImmediatePropagation();
  }
});


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the PWA service worker in production only (avoids dev hot-reload cache issues).
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
